export default __webpack_public_path__ + "static/bgm-e8fe95e4352a04b32d768b5a3d3efd32.webm";